import React, { Component } from "react";
import store from "../../Store";
import * as QueryString from "querystring";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import API from "../../Api";
import { getSafely, isNonEmptyString } from "@tomeravni/easybizy-js-common/common";
import { push } from "connected-react-router";

const ERROR_PATH = '/error';

class RedirectToContext extends Component {
	componentWillMount() {
		let token;
		let contextName;

		try {
			token = new URL(window.location.href).searchParams.get('token')
		} catch (e) {
		}

		try {
			contextName = window.location.pathname.split('/').filter((x) => isNonEmptyString(x))[0];
		} catch (e) {
		}

		API.resolveContext(contextName, token).then(this.handleSuccessfullyFoundContext).catch(this.handleErrorIfNeeded);
	}

	handleErrorIfNeeded = () => {
		let path = { pathname: ERROR_PATH, search: QueryString.stringify({ error: 'identify_business_failed' }) };
		store.dispatch(push(path));
	}

	handleSuccessfullyFoundContext = (iData) => {
		const data = getSafely(['data'], iData);
		if (data.context) {
			const parsed = QueryString.parse(this.props.location.search);
			delete parsed['base_url']
			delete parsed['?base_url']
			delete parsed['token']
			delete parsed['?token']
			const customerToken = data.customerToken ? `/${ data.customerToken }` : ''
			let firstUriParam = this.props.match.params.oldRoute;
			const route = (isNonEmptyString(firstUriParam) && firstUriParam !== data.context) ? firstUriParam : 'welcome'
			let parsedQueryString = QueryString.stringify(parsed);
			const queryParams = isNonEmptyString(parsedQueryString) ? `?${ parsedQueryString }` : ''
			return window.location.href = `/${ data.context }${ customerToken }/${ route }${ queryParams }`

		}

		this.handleErrorIfNeeded();
	}

	render() {
		return (<div></div>);
	}

}

export default connect()(injectIntl(RedirectToContext));
